var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('intranet-nav-content',[_c('template',{slot:"links"},[_c('intranet-nav-content-link-exact',{attrs:{"link":{ name: 'Visa', path: { name: 'employee-visa' } }}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }